export const setAcceptWarnings = (answer) =>
  window.localStorage.setItem('show_warnings', answer);

export const getAcceptWarnings = () =>
  window.localStorage.getItem('show_warnings');

export const deleteAcceptWarnings = () =>
  window.localStorage.removeItem('show_warnings');
